export default __webpack_public_path__ + "static/media/SuraSans-Seminegrita.f4a89224.otf";